export enum StorageKeys {
  lang = "lang",
  user = "user",
}
